import useSWR from "swr";
import { fetchProgressTree } from "../services/progressTree";
import { EnrollmentProgressTrigger } from "../types";

export const useProgressTree = (trigger: EnrollmentProgressTrigger | null) => {
  const key = trigger
    ? `enrollment-progress/${trigger.corporateId}/${trigger.userId}/${trigger.objectType}/${trigger.objectId}`
    : null;

  const { data, error, isLoading, mutate } = useSWR(
    key,
    () => fetchProgressTree(trigger as EnrollmentProgressTrigger),
    { onError: () => null },
  );

  return { tree: data ?? null, isLoading, hasError: !!error, mutate };
};
